<template>
  <portal to="modals">
    <app-modal @close="confirmClose">
      <template #containerless>
        <form
          class="w-screen text-black"
          @submit.prevent="save"
        >
          <div class="bg-white flex flex-col min-h-screen">
            <div class="flex flex-1">
              <div class="w-64 sticky pin-t self-start px-12 pt-16">
                <p class="font-bold text-xs text-primary-900 uppercase mt-16">
                  Sections
                </p>
                <ul class="list-reset">
                  <li
                    v-for="(content, index) in editor.sections"
                    :key="index"
                  >
                    <button
                      type="button"
                      class="w-full text-left block focus:outline-none py-2 focus:underline focus:text-primary-900 hover:underline hover:text-primary-900 transition-all transition-normal"
                      :class="{
                        'text-primary-500 underline font-bold':
                          currentSection === index
                      }"
                      @click="setSection(index)"
                    >
                      {{ content.heading || "Section..." }}
                    </button>
                  </li>
                  <li class="mt-6">
                    <button
                      type="button"
                      class="w-full text-left block focus:outline-none py-2 text-xs uppercase font-bold text-primary-900 leading-none focus:underline hover:underline"
                      @click="addSection"
                    >
                      <icon
                        icon="add-circle"
                        class="w-6 h-6 icons-primary align-middle mr-2"
                      />
                      Add New Section
                    </button>
                  </li>
                </ul>
              </div>
              <div class="flex-1 flex flex-col">
                <div
                  class="bg-white max-w-lg mx-auto w-full mb-12 sticky z-10 pin-t px-6"
                >
                  <label
                    class="text-xs font-bold block pt-6 text-grey-600 uppercase"
                    :for="_uid + '_title'"
                  >
                    Contract Title
                  </label>
                  <input
                    :id="_uid + '_title'"
                    ref="contractTitle"
                    v-model="editor.title"
                    type="text"
                    class="w-full pt-1 pb-6 border-b text-2xl font-bold focus:outline-none transition-all transition-normal"
                    @blur="checkEmptyTitle"
                  />
                </div>
                <div
                  v-if="currentSection === null"
                  class="text-center w-full"
                >
                  <svg
                    id="b783d195-b08f-4839-b9b5-a9b86d08906a"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-64 h-64 block mb-8 mx-auto"
                    viewBox="0 0 574.99478 764"
                  >
                    <title>terms</title>
                    <path
                      d="M869.443,802.83547H313.68507V92.17481s590.04937-54.39333,555.75792,0S869.443,802.83547,869.443,802.83547Z"
                      transform="translate(-312.50261 -68)"
                      fill="#f2f2f2"
                    />
                    <polygon
                      points="558.123 736.018 0 736.018 0 22.992 332.43 22.992 332.43 25.357 2.365 25.357 2.365 733.653 555.758 733.653 555.758 170.13 558.123 170.13 558.123 736.018"
                      fill="#3f3d56"
                    />
                    <path
                      d="M719.65,276.153c-15.43323.00116-32.03622-3.17209-47.12764-12.7034-43.77829-27.65163-85.79617-.29619-86.21477-.01616l-.13568.07794c-.38915.19054-26.33984,12.63931-56.89856,12.64162-15.43323.00116-32.03622-3.17209-47.12764-12.7034-43.77829-27.65163-85.79559-.29619-86.21477-.01616l-1.31179-1.9677c.433-.28811,43.72864-28.47381,88.78985-.01616,43.20727,27.29135,99.48746,1.00578,101.66186-.03291,2.06411-1.32854,44.541-27.86354,88.71479.03291,43.86894,27.70648,101.14915.22,101.72248-.06178l1.04043,2.12358C776.15943,263.70191,750.20874,276.15068,719.65,276.153Z"
                      transform="translate(-312.50261 -68)"
                      fill="#3f3d56"
                    />
                    <path
                      d="M719.65,332.91125c-15.43323.00115-32.03622-3.1721-47.12764-12.7034-43.77829-27.65106-85.79617-.29619-86.21477-.01617l-.13568.07795c-.38915.19053-26.33984,12.63931-56.89856,12.64162-15.43323.00115-32.03622-3.1721-47.12764-12.7034-43.77829-27.65106-85.79559-.29619-86.21477-.01617l-1.31179-1.96769c.433-.28811,43.72864-28.47382,88.78985-.01617,43.20727,27.29078,99.48746,1.00637,101.66186-.03291,2.06411-1.32911,44.541-27.86411,88.71479.03291,43.86894,27.70764,101.14915.21941,101.72248-.06178l1.04043,2.12359C776.15943,320.46016,750.20874,332.90894,719.65,332.91125Z"
                      transform="translate(-312.50261 -68)"
                      fill="#3f3d56"
                    />
                    <path
                      d="M719.65,389.66951c-15.43323.00115-32.03622-3.1721-47.12764-12.70341-43.77829-27.65221-85.79617-.29677-86.21477-.01616l-.13568.07794c-.38915.19054-26.33984,12.63932-56.89856,12.64163-15.43323.00115-32.03622-3.1721-47.12764-12.70341-43.77829-27.65221-85.79559-.29677-86.21477-.01616l-1.31179-1.9677c.433-.28811,43.72864-28.47439,88.78985-.01616,43.20727,27.29135,99.48746,1.00636,101.66186-.03291,2.06411-1.32854,44.541-27.86469,88.71479.03291,43.86894,27.70648,101.14915.22,101.72248-.06178l1.04043,2.12358C776.15943,377.21842,750.20874,389.6672,719.65,389.66951Z"
                      transform="translate(-312.50261 -68)"
                      fill="#3f3d56"
                    />
                    <path
                      d="M540.41844,446.52014c-.47634,0-.95382-.01386-1.43536-.04388-7.73855-.48037-14.60411-4.87651-20.40384-13.06888-5.74777-8.11789-11.85813-12.19127-18.29817-12.11217-10.74552.13569-18.80625,11.96841-18.88651,12.08792l-.10912.13857c-.51675.56641-12.82176,13.8749-27.43974,12.95456-7.73855-.48037-14.60412-4.87651-20.40385-13.06888-5.74776-8.11789-11.91066-12.19127-18.29816-12.11217-10.74552.13569-18.80625,11.96841-18.88651,12.08792l-1.96423-1.31757c.35566-.53,8.84654-12.984,20.82072-13.13527,7.25125-.1253,14.03367,4.32049,20.25777,13.111,5.36381,7.57458,11.62544,11.637,18.61052,12.07349,13.02789.8037,24.61407-11.18722,25.5038-12.13065.82276-1.19863,9.15717-12.90721,20.76529-13.05386.07275-.00116.14665-.00116.21882-.00116,7.13751,0,13.87721,4.40941,20.039,13.11218,5.36381,7.57458,11.62544,11.637,18.61053,12.07349,13.50191.85451,25.43855-12.0579,25.55749-12.18838l1.746,1.59528C565.92282,434.06963,554.388,446.519,540.41844,446.52014Z"
                      transform="translate(-312.50261 -68)"
                      fill="#3f3d56"
                    />
                    <polygon
                      points="334.637 603.582 223.486 603.582 223.486 527.904 308.623 527.904 308.623 530.269 225.851 530.269 225.851 601.217 332.272 601.217 332.272 565.743 334.637 565.743 334.637 603.582"
                      fill="#3f3d56"
                    />
                    <path
                      d="M382.268,172.58234a14.18957,14.18957,0,1,1,14.18956-14.18956A14.20583,14.20583,0,0,1,382.268,172.58234Zm0-26.0142a11.82464,11.82464,0,1,0,11.82463,11.82464A11.83781,11.83781,0,0,0,382.268,146.56814Z"
                      transform="translate(-312.50261 -68)"
                      fill="#0072c4"
                    />
                    <polygon
                      points="308.091 577.802 279.96 538.955 287.623 533.408 309.155 563.144 391.554 478.489 398.332 485.087 308.091 577.802"
                      fill="#0072c4"
                    />
                    <path
                      d="M725.77366,337.536S739.96322,374.1924,713.949,374.1924s40.20377,36.65637,66.218,15.372,10.64217-22.46681,10.64217-22.46681-34.29145,3.5474-33.109-27.19666Z"
                      transform="translate(-312.50261 -68)"
                      fill="#a0616a"
                    />
                    <circle
                      cx="429.25668"
                      cy="234.94048"
                      r="46.09372"
                      fill="#2f2e41"
                    />
                    <path
                      d="M718.67888,490.07384,673.74526,605.95527s-22.46681,35.47391-14.18957,70.94782,27.19667,99.327,27.19667,99.327,21.28434-8.27724,20.10188-23.64927,9.45971-69.76536-8.27724-89.86724l62.67057-88.68477,2.36493,93.41462s-4.72986,42.5687-3.54739,61.48812,3.54739,50.84593,3.54739,50.84593l14.18956-2.36492s24.83174-87.50232,22.46681-115.88144c0,0,44.93362-138.34825,0-171.45723Z"
                      transform="translate(-312.50261 -68)"
                      fill="#2f2e41"
                    />
                    <path
                      d="M690.29975,770.31772s-10.64217,0-9.45971,9.45971-9.45971,55.57579,13.0071,52.0284,24.83174-26.0142,24.83174-41.38622,1.18246-16.5545,3.54739-20.10189,9.45971-34.29144,0-33.109-20.10188,7.09478-20.10188,7.09478S705.67178,770.31772,690.29975,770.31772Z"
                      transform="translate(-312.50261 -68)"
                      fill="#2f2e41"
                    />
                    <path
                      d="M770.70728,770.31772s-16.55449-2.36492-15.372,3.54739-2.36493,30.74406,0,33.109,7.09478,7.09478,7.09478,10.64217,1.18247,15.372,21.28435,11.82464,15.372-21.28435,14.18956-23.64928-15.372-14.18956-14.18956-21.28434S777.80206,765.58787,770.70728,770.31772Z"
                      transform="translate(-312.50261 -68)"
                      fill="#2f2e41"
                    />
                    <circle
                      cx="429.82554"
                      cy="254.164"
                      r="31.92652"
                      fill="#a0616a"
                    />
                    <path
                      d="M772.481,364.14146s10.2159,20.21214-20.862,20.56333c-9.76174.11031-19.07214-8.27783-25.254-15.83348-2.18248-2.66747-3.104,2.80835-7.09478,2.36493-10.64217-1.18247-39.61253.59123-39.61253,19.51065s33.109,91.0497,30.744,98.14448-14.18956,5.91232,0,10.64217,42.56869-7.09478,61.48811,2.36493,36.65638-14.18956,36.65638-14.18956L836.92524,386.017S793.76532,359.4116,772.481,364.14146Z"
                      transform="translate(-312.50261 -68)"
                      fill="#575a89"
                    />
                    <path
                      d="M690.29975,555.10934s-29.56159,23.64927-16.55449,31.92652,28.37913-31.92652,28.37913-31.92652Z"
                      transform="translate(-312.50261 -68)"
                      fill="#a0616a"
                    />
                    <path
                      d="M803.81626,469.972s-39.0213,15.372-26.0142,23.64928,26.0142-14.18957,26.0142-14.18957Z"
                      transform="translate(-312.50261 -68)"
                      fill="#a0616a"
                    />
                    <path
                      d="M691.48221,378.92225h0a22.75467,22.75467,0,0,0-15.044,21.02828l-1.51045,90.1233s-7.09478,73.31274,10.64218,73.31274,30.74405,5.91232,33.109,0-8.27725-59.12318-8.27725-59.12318Z"
                      transform="translate(-312.50261 -68)"
                      fill="#575a89"
                    />
                    <path
                      d="M814.45843,382.46964l22.46681,3.54739s62.67058,30.74406,48.481,52.0284S810.911,490.07384,810.911,490.07384s-22.46681-10.64218-15.372-17.737,39.0213-31.92652,39.0213-31.92652l-27.19667-24.83174Z"
                      transform="translate(-312.50261 -68)"
                      fill="#575a89"
                    />
                    <polygon
                      points="459.681 229.613 436.289 217.361 403.987 222.373 397.304 251.891 413.941 251.251 418.588 240.406 418.588 251.072 426.265 250.777 430.72 233.512 433.505 251.891 460.794 251.334 459.681 229.613"
                      fill="#2f2e41"
                    />
                    <circle
                      cx="431.68266"
                      cy="182.37747"
                      r="18.59922"
                      fill="#2f2e41"
                    />
                    <path
                      d="M720.73408,244.71684a18.60362,18.60362,0,0,1,15.7689-18.38521,18.59923,18.59923,0,1,0,0,36.77042A18.60365,18.60365,0,0,1,720.73408,244.71684Z"
                      transform="translate(-312.50261 -68)"
                      fill="#2f2e41"
                    />
                    <path
                      d="M382.01343,763.063c6.70634,24.79066,29.67707,40.14415,29.67707,40.14415s12.09761-24.84013,5.39127-49.6308-29.67708-40.14415-29.67708-40.14415S375.30709,738.27234,382.01343,763.063Z"
                      transform="translate(-312.50261 -68)"
                      fill="#3f3d56"
                    />
                    <path
                      d="M391.86793,757.73523c18.40229,17.91389,20.65,45.45171,20.65,45.45171s-27.58831-1.50633-45.99061-19.42023-20.65-45.45171-20.65-45.45171S373.46563,739.82133,391.86793,757.73523Z"
                      transform="translate(-312.50261 -68)"
                      fill="#0072c4"
                    />
                  </svg>
                  <h3>
                    <template v-if="!editor.sections.length">
                      Create a new section to get started.
                    </template>
                    <template v-else>
                      Select your section from the left to edit.
                    </template>
                  </h3>
                  <div class="max-w-xs mx-auto mt-6">
                    <app-button @click="addSection">
                      New Section
                    </app-button>
                  </div>
                </div>
                <div
                  v-else
                  class="max-w-lg mx-auto w-full px-6 flex-1 overflow-y-auto"
                >
                  <input
                    ref="sectionHeading"
                    v-model="editor.sections[currentSection].heading"
                    type="text"
                    class="block text-xl font-bold w-full focus:outline-none mb-12"
                    autofocus
                    @blur="checkEmptyHeading"
                  />
                  <div class="block w-full">
                    <textarea
                      class="w-full border p-4"
                      style="field-sizing: content; min-height: 30rem;"
                      :value="editor.sections[currentSection].content"
                      @input="handleInput($event.target.value)"
                    />
                  </div>
                </div>
                <div
                  class="max-w-lg mx-auto mt-auto w-full sticky z-10 pin-b px-6 bg-white self-end"
                >
                  <div class="border-t-4 py-4 text-right">
                    <button
                      v-if="currentSection !== null"
                      class="text-negative-700 px-6 py-2 hover:underline uppercase text-xs font-bold"
                      type="button"
                      @click="removeSection"
                    >
                      Delete Section
                    </button>
                    <button
                      class="text-white button--primary px-6 py-2 uppercase text-xs font-bold"
                      type="submit"
                    >
                      Save &amp; Exit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
    </app-modal>
  </portal>
</template>

<script>
export default {
  name: "ContractBuilder",
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editor: {},
      currentSection: null
    };
  },
  created() {
    this.editor = Object.assign({}, this.contract);
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.contractTitle.focus();
    });
  },
  destroyed() {
    this.editor = {};
    this.currentSection = null;
  },
  methods: {
    handleInput(value) {
      this.editor.sections[this.currentSection].content = value;
    },
    checkEmptyTitle(e) {
      if (e.target.value.length) return;
      this.editor.title = "New Contract";
    },
    checkEmptyHeading(e) {
      if (e.target.value.length) return;
      this.editor.sections[this.currentSection].heading =
        "Section " + this.editor.sections.length;
    },
    addSection() {
      this.editor.sections.push({
        heading: "New Section",
        content: ""
      });
      this.setSection(this.editor.sections.length - 1);
    },
    removeSection() {
      if (!confirm("Are you sure you want to remove this section?")) return;
      const currentSection = this.currentSection;
      this.currentSection = null;
      this.editor.sections.splice(currentSection, 1);
    },
    setSection(index) {
      this.currentSection = index;
      this.$nextTick(() => this.$refs.sectionHeading.focus());
    },
    confirmClose() {
      if (JSON.stringify(this.editor) === JSON.stringify(this.contract))
        return this.$emit("close");
      if (confirm("Would you like to save your changes?")) {
        return this.save();
      }
      return this.$emit("close");
    },
    save() {
      this.$emit("save:contract", this.editor);
    }
  }
};
</script>
<style>
@import "~simplemde/dist/simplemde.min.css";
</style>
